<template>
  <div id="app" :class="{'all-bg':loginStatus}">
    <!--这里判断是首页的顶部菜单还是登录后的顶部菜单-->
    <navClass v-if="loginStatus"/>
    <navSite v-else/>
    <router-view :class="{'container':loginStatus}"/>
     <footerSite v-if="!loginStatus" />
     <fixed-router v-if="!loginStatus"></fixed-router>
    <!-- <div class="fixed-router" v-if="!loginStatus"> -->
      <!-- <route-link to="/help" tag="div" class="fixed-router-item">帮助中心</route-link> -->
      <!-- <div class="fixed-router-item">媒体报道</div>
      <div class="fixed-router-item">服务条款</div>
      <div class="fixed-router-item" @click="$router.push({path: '/help'})">帮助中心</div>
      <div class="fixed-router-item">视频教程</div> -->
    <!-- </div> -->
  </div>
</template>

<script>
    import navSite from './components/navSite'
    import navClass from './components/navClass'
    import footerSite from './components/footerSite'
    import { mapGetters } from 'vuex'
    import fixedRouter from './components/fixedRouter'
  export default {
    components: {
        navSite,
        navClass,
        footerSite,
        fixedRouter
    },
    name: 'app',
    provide() {
      return {
        reload: this.reload
      }
    },
    computed: {
    ...mapGetters([
        'loginStatus',
      ])
    },
    data() {
      return {
        isRouterAlive: true,
        isLogin:null,
      }
    },
    methods: {
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      }
    },
    created(){
        this.isLogin = JSON.parse(sessionStorage.getItem('isLogin'));
        this.$store.dispatch('common/updateLogin',this.isLogin )
    },
  }

</script>

<style lang="scss">
    body {
        font-family:Microsoft YaHei,Verdana, Arial, Helvetica, sans-serif;
    }
  @import url("//at.alicdn.com/t/font_1475136_61d9itzl27s.css");
  @import "../static/css/index.less";
  #app{
    /*min-width: 1200px;*/
    width: 100%;
    position: relative;
  }
  /*下面此样式要做判断是首页还是登录后的菜单页*/
  /*底部菜单的样式，保留下面样式不展示*/
    .container{
    min-height: calc(100vh - 430px);
  }
  .all-bg{
    width: 100%;
    height: 100%;
    background: url("../static/img/bg_Whole.jpg") no-repeat center;
    background-size: 100% 100%;
  }

  html,body{
    padding: 0;
    margin: 0;
  }
  ul,ol,li{
    list-style: none;
    padding: 0;
  }
  a{
    text-decoration: none;
  }
  .current-position{
      height: 100px;
      line-height: 100px;
      color:#aaa;
  }
  .current-current{
      color:#333!important;
  }
// .fixed-router{
//   position: fixed;
//   bottom: 30px;
//   right: 70px;
//   z-index: 9999;
// }
// .fixed-router-item{
//   width: 80px;
//   height: 80px;
//   text-align: center;
//   line-height: 80px;
//   background:#fff;
//   margin-bottom: 10px;
//   cursor: pointer;
// }
// .fixed-router-item:hover{
//   color:#ce1212;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue